<template>
  <div>
    <Header></Header>
    <div id="main">
      <div class="container">
        <div class="row">
          <div class="col-md-8 offset-md-2">
            <div v-if="showMsg" class="alert alert-danger alert-dismissible fade show" role="alert">
              {{msg}}
              <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" v-on:click.stop.prevent="hideMsg()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div v-if="showMsgSuccess" class="alert alert-success alert-dismissible fade show" role="alert">
              {{msgSuccess}}
              <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" v-on:click.stop.prevent="hideMsg()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form class="signup-form">

              <button class="login-facebook" v-on:click.stop.prevent="loginFacebook()">Cadastrar com Facebook <font-awesome-icon :icon="['fab', 'facebook']" size="lg" /></button>

              <button class="login-google" v-on:click.stop.prevent="loginGoogle()">Cadastrar com Google <font-awesome-icon :icon="['fab', 'google']" size="lg" /></button>

              <h5>Ou</h5>

              <div class="form-group">
                <label for="nameInput">Nome</label>
                <input v-model="fullname" type="text" class="form-control" id="nameInput" placeholder="Informe seu nome completo">
              </div>

              <div class="form-group">
                <label for="emailInput">E-mail</label>
                <input v-model="email" type="email" class="form-control" id="emailInput" aria-describedby="emailHelp" placeholder="Informe seu e-mail">
                <small id="emailHelp" class="form-text text-muted">Nós não compartilharemos o seu email com ninguém.</small>
              </div>

              <div class="form-group">
                <label for="passwordInput">Senha</label>
                <input v-model="password" type="password" class="form-control" id="passwordInput" aria-describedat="passwordHelp" placeholder="Insira uma senha">
                <small id="passwordHelp" class="form-text text-muted">Senha com no mínimo 6 dígitos, e uma letra maiúscula, uma minúscula e um número.</small>
              </div>

              <div class="form-group">
                <label for="confirmPasswordInput">Confirme a Senha</label>
                <input v-model="confirmPassword" type="password" class="form-control" id="confirmPasswordInput" placeholder="Confirme a senha digitada">
              </div>

              <div class="form-check">
                <input class="form-check-input" type="checkbox" value="" id="defaultCheck1">
                <label class="form-check-label" for="defaultCheck1">
                  Receber atualizações da click2giv
                </label>
              </div>

              <div class="form-check">
                <input v-model="terms" class="form-check-input" type="checkbox" value="" id="defaultCheck2" required>
                <label class="form-check-label" for="defaultCheck2">
                  Eu concordo com os <router-link to="/terms-and-conditions">termos de uso</router-link> do site e tenho mais de 18 anos.
                </label>
              </div>

              <button type="submit" class="btn" v-on:click.stop.prevent="register()">Cadastrar</button>

            </form>

          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
    <Loading v-if="loading"></Loading>
  </div>
</template>

<script>

import Header from './includes/Header'
import Footer from './includes/Footer'
import Loading from './includes/Loading'
import auth from '../services/auth'
import Functions from '../utils/functions'
import { API } from '../services/api'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import {faFacebookF} from '@fortawesome/fontawesome-free-brands'

export default {
  name: 'Signup',
  components: {
    Header,
    Footer,
    Loading,
    FontAwesomeIcon
  },
  data () {
    return {
      fullname: null,
      email: null,
      password: null,
      confirmPassword: null,
      receiveNewsletter: false,
      terms: false,
      showMsgSuccess: false,
      msgSuccess: "",
      showMsg: false,
      msg: "",
      loading: false
    }
  },
  methods: {
    register(){
      this.showMsg = false;
      this.loading = true;
      if(this.validate()){
        this.$http.post(API.Auth.register, {fullname: this.fullname, email: this.email,
          password: this.password, passwordConfirm: this.confirmPassword,
          receiveNewsletter: this.receiveNewsletter}).then((response) => {
            if(response.body.success === false){
              this.showMessage(response.body.message);
            }else{
              this.msgSuccess = "Cadastro efetuado com sucesso! Você receberá um e-mail com link para ativação da sua conta.";
              this.showMsgSuccess = true;
              this.fullname = null;
              this.email = null;
              this.password = null;
              this.confirmPassword = null;
              this.receiveNewsletter = null;
              this.terms = null;
            }
            this.loading = false;
          }, (error) => {
            console.log("ERROR")
            this.showMessage(error.body.message);
            this.loading = false;
          });
      }else{
        this.loading = false;
      }
    },
    loginFacebook(){
        this.loading = true;
        var $this = this;
        FB.login(function(response) {
          if (response.status == "unknown" || response.status == undefined) {
            $this.msg = 'Erro ao autenticar no Facebook.';
            $this.showMsg = true;
            $this.loading = false;
          }else {
            $this.prepareLoginFacebook((dataUser) => {
              $this.$http.post(API.Auth.loginFacebook, 
              {facebookId: dataUser.id, name: dataUser.name, email: dataUser.email, picture: dataUser.picture.data.url}).then((rtrn) => {
                if(rtrn.body.success == true){
                  auth.setAuthToken(rtrn.body.token);
                  $this.loading = false;
                  if($this.$route.params.ProjectSlug){
                    $this.$router.push('/project/' + $this.$route.params.ProjectSlug);
                  }else{
                    $this.$router.push('/dashboard');
                  }
                }else{
                  $this.msg = rtrn.body.message;
                  $this.showMsg = true;
                  $this.loading = false;
                }
              });
            });
          }
        });
      },
      loginGoogle(){
        var $this = this;
        var auth2 = gapi.auth2.getAuthInstance();
        auth2.signIn().then(
          function(response) {
            var profile = auth2.currentUser.get().getBasicProfile()
            $this.$http.post(API.Auth.loginGoogle, {
              googleId: profile.getId(), name: profile.getName(), email: profile.getEmail(), picture: profile.getImageUrl()
            }).then((rtrn) => {
              if(rtrn.body.success == true){
                  auth.setAuthToken(rtrn.body.token);
                  $this.loading = false;
                  if($this.$route.params.ProjectSlug){
                    $this.$router.push('/project/' + $this.$route.params.ProjectSlug);
                  }else{
                    $this.$router.push('/dashboard');
                  }
                }else{
                  $this.msg = rtrn.body.message;
                  $this.showMsg = true;
                  $this.loading = false;
                }
            });
          },
          function(error) {
            $this.msg = 'Erro ao autenticar no Google.';
            $this.showMsg = true;
            $this.loading = false;
          }
        );
      },
    validate(){
      var lowerCaseLetters = /[a-z]/g;
      var upperCaseLetters = /[A-Z]/g;
      var numbers = /[0-9]/g;
      if(this.fullname == '' || this.fullname == null){
        this.showMessage("Insira o seu nome completo.");
        return false;
      }
      if(this.email == '' || this.email == null){
        this.showMessage("Insira o seu email de usuário.");
        return false;
      }
      if(!Functions.validateEmail(this.email)){
        this.showMessage("E-mail inválido. Insira um e-mail no formato correto.");
        return false;
      }
      if(this.password == '' || this.password == null){
        this.showMessage("Insira uma senha válida.");
        return false;
      }
      if(!this.password.match(lowerCaseLetters) || !this.password.match(upperCaseLetters) || !this.password.match(numbers)){
        this.showMessage("Sua senha precisa ter ao menos um caractere maiúsculo, um minúsculo e um número.");
        return false;
      }
      if(this.password.length < 6){
        this.showMessage("Sua senha precisa ter ao menos 6 dígitos");
        return false;
      }
      if(this.confirmPassword == '' || this.confirmPassword == null){
        this.showMessage("Confirme a senha inserida.");
        return false;
      }
      if(this.confirmPassword !== this.password){
        this.showMessage("Senhas não conferem.");
        return false;
      }
      if(this.terms == false){
        this.showMessage("Você deve ler e concordar com nossos termos de uso.");
        return false;
      }
      return true;
    },
    showMessage(msg){
        this.msg = msg;
        this.showMsg = true;
    },
    hideMsg(){
        this.msg = "";
        this.showMsg = false;
        this.msgSuccess = "";
        this.showMsgSuccess = false;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

  .signup-form{
    width: 100%;
    padding: 20px;
    background-color: #eee;
    border-radius: 5px;
    margin-bottom: 40px;
    font-family: RalewayRegular;

    input{
      padding: 10px;
      border-color: #00ae39;
    }

    .form-check{
      padding-bottom: 10px;
    }

    h5{
      position: relative;
      text-align: center;
      margin: 30px 0px;
      font-family: RalewayRegular;

      &.minor{
        font-size: 16px;
      }

      &::before{
        position: absolute;
        content: " ";
        width: 35%;
        border-bottom: 1px solid #d9d9d9;
        height: 1px;
        top: 50%;
        right: 0;
      }

      &::after{
        position: absolute;
        content: " ";
        width: 35%;
        border-bottom: 1px solid #d9d9d9;
        height: 1px;
        top: 50%;
        left: 0;
      }
    }

    button{
      width: 100%;
      margin-top: 20px;
      padding: 10px;
      font-size: 20px;
      background-color: #00ae39;
      color: #fff;
      cursor: pointer;

      &.login-facebook{
        background-color: #3b5998;
        border: none;
        border-radius: 5px;

        svg{
          margin-left: 10px;
        }
      }

      &.login-google{
        background-color: #D84B37;
        border: none;
        border-radius: 5px;

        svg{
          margin-left: 10px;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Signup.vue